module.exports = __webpack_public_path__ + "img/b2.4e4dc6c6.png";